import {BatchRequest} from '../../../../services/proto/core/batchRequest';
import {priority} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../../../../services/proto/core/loginProps';
import {batchKeys} from '../../../../services/proto/core/constants';
import {handleBatchCriticalError} from './handleBatchCriticalError';

type ResponseType = [
    priority.netitems.form.ISubform,
    undefined | priority.netitems.form.IHtmlFetchRs,
    undefined | priority.netitems.form.IEndRs
];

export const fetchHTMLData = async (
    session: string,
    formName: string,
    keys: priority.netitems.form.IField[],
    closeSession: boolean = false
) => {
    const batchRequest = new BatchRequest(session);
    batchRequest.addTask({
        key: batchKeys.Subform,
        request: new priority.netitems.form.SubformRq({
            Session: session,
            Fname: formName,
            Keys: keys,
            Properties: getAdditionalProps()
        })
    });

    batchRequest.addTask({
        key: batchKeys.HtmlFetch,
        request: new priority.netitems.form.HtmlFetchRq({
            Session: session,
            Properties: getAdditionalProps()
        })
    });

    if (closeSession) {
        batchRequest.addTask({
            key: batchKeys.End,
            request: new priority.netitems.form.EndRq({
                Session: session,
                Properties: getAdditionalProps()
            })
        });
    }

    const res = await batchRequest.getData();

    res.forEach(r => {
        if (r.FatalError) {
            handleBatchCriticalError(r, session);
            return;
        }
    });

    return [res[0]?.Subform, res[1]?.HtmlFetch, res[2]?.End] as ResponseType;
};
